/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCloudAccountSyncDetails {
    getFixupPrototypeFunction() { return AwsSsmCloudAccountSyncDetails.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCloudAccountSyncDetails>): AwsSsmCloudAccountSyncDetails {
        let obj = Object.assign(new AwsSsmCloudAccountSyncDetails(), model);
        AwsSsmCloudAccountSyncDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCloudAccountSyncDetails>): AwsSsmCloudAccountSyncDetails {
        if (!model) return null;
        return AwsSsmCloudAccountSyncDetails.newInstance(<AwsSsmCloudAccountSyncDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCloudAccountSyncDetails) {
        if (!obj) return;

        models.AwsSsmCloudAccountSyncDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCloudAccountSyncDetails): boolean {
        Object.setPrototypeOf(obj, AwsSsmCloudAccountSyncDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.initiated_at === "string") {
            this.initiated_at = new Date(<string><any>this.initiated_at);
        }
        if (typeof this.completed_at === "string") {
            this.completed_at = new Date(<string><any>this.completed_at);
        }
    }

    /**
     * Time when the document sync is started
     */
    initiated_at: Date;

    /**
     * Time when the document sync is completed
     */
    completed_at: Date;

    /**
     * Type of the document sync
     */
    sync_type: models.AwsSsmDocumentSyncType;

    /**
     * Status of the sync for the particular cloud account
     */
    sync_status: string;

}
